import { render, staticRenderFns } from "./userServiceList.vue?vue&type=template&id=6b5e6e1e"
import script from "./userServiceList.vue?vue&type=script&lang=js"
export * from "./userServiceList.vue?vue&type=script&lang=js"
import style0 from "./userServiceList.vue?vue&type=style&index=0&id=6b5e6e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports